import getEnvironment from "./getEnvironment";
import endpoints from "./endpoints.json";

const env = getEnvironment();

const getHomePageEndpoint = () => {
  return endpoints[env].homePage;
};

const getLoginEndpoint = () => {
  return endpoints[env].login;
};

const getRegistrationEndpoint = () => {
  return endpoints[env].registration;
};

const getPswdHelpEndpoint = () => {
  return endpoints[env].pswdHelp;
};

const getAutheEndpoint = () => {
  return endpoints[env].authe;
};

const getErrorPageEndpoint = (error) => {
  return error === "login"
    ? endpoints[env].loginError
    : endpoints[env].genericError;
};

const getJourneyParams = () => {
  return endpoints[env].journeyParams;
};

const getPartnerJourneyParams = () => {
  return endpoints[env].partnerJourneyParams;
};

const getTermsOfUse = () => {
  return endpoints[env].termsOfUse;
};

const getPartnerErrorEndpoint = () => {
  return endpoints[env].partnerError;
};

export {
  getHomePageEndpoint,
  getLoginEndpoint,
  getRegistrationEndpoint,
  getPswdHelpEndpoint,
  getAutheEndpoint,
  getErrorPageEndpoint,
  getJourneyParams,
  getPartnerJourneyParams,
  getTermsOfUse,
  getPartnerErrorEndpoint,
};
